angular.module("vgresiduos").directive("disposalCostInformation", function () {
	return {
		scope: true,
		controller: "DisposalCostInformationCtrl",
		controllerAs: "ctrl",
		templateUrl:
			"views/destination/baseComponents/destinationSlip/disposalCostInformation/disposalCostInformation_template.html"
	};
});
